import "babel-polyfill"
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'

import messages from './messages'
import App from './App'

import 'bootstrap/dist/css/bootstrap.min.css'

addLocaleData([...en, ...es])

let locale = 
  (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage
  || 'en'

const allowedLanguages = ['es', 'en']
locale = locale.substring(0,2)
locale = allowedLanguages.includes(locale) ? locale : 'en'

ReactDOM.render((
  <IntlProvider locale={locale} messages={messages[locale]} >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </IntlProvider>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js